var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9223 8.33909C14.2477 8.01365 14.2477 7.48602 13.9223 7.16059C13.5968 6.83514 13.0692 6.83514 12.7438 7.16059L8.84426 11.0601L7.26661 9.42184C6.94737 9.09034 6.41982 9.08034 6.08831 9.39959C5.75679 9.71884 5.74683 10.2463 6.06607 10.5779L8.23274 12.8279C8.38792 12.9891 8.60143 13.0811 8.82518 13.0832C9.04884 13.0853 9.26409 12.9973 9.42226 12.8391L13.9223 8.33909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 0.833252C4.93707 0.833252 0.833008 4.93731 0.833008 9.99992C0.833008 15.0625 4.93707 19.1666 9.99967 19.1666C15.0623 19.1666 19.1663 15.0625 19.1663 9.99992C19.1663 4.93731 15.0623 0.833252 9.99967 0.833252ZM2.49967 9.99992C2.49967 5.85779 5.85754 2.49992 9.99967 2.49992C14.1418 2.49992 17.4997 5.85779 17.4997 9.99992C17.4997 14.1421 14.1418 17.4999 9.99967 17.4999C5.85754 17.4999 2.49967 14.1421 2.49967 9.99992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.4602f58a763117d60bfd12f7fb64cd09.svg";
export { ForwardRef as ReactComponent };